/* Bear Baby Boutique – "Combineer met" in de cart.
   Laadt één aanvullend product (Search & Discovery, intent complementary; valt terug op
   related) via de Section Rendering API van sections/bb-cart-upsell.liquid. De knop voegt het
   product toe via /cart/add.js en ververst drawer, cart-pagina en het icoon in de header. */
(() => {
  if (!customElements.get('bb-cart-upsell')) {
    class BBCartUpsell extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded) return;
        this.dataset.loaded = 'true';
        this.load('complementary')
          .then((ok) => (ok ? true : this.load('related')))
          .then((ok) => {
            if (!ok) this.remove();
          });
      }

      async load(intent) {
        try {
          const response = await fetch(`${this.dataset.url}&intent=${intent}`);
          if (!response.ok) return false;
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const content = doc.querySelector('.bb-upsell');
          if (!content) return false;
          this.innerHTML = content.outerHTML;
          return true;
        } catch (error) {
          return false;
        }
      }
    }
    customElements.define('bb-cart-upsell', BBCartUpsell);
  }

  if (window.bbCartUpsellBound) return;
  window.bbCartUpsellBound = true;

  const replaceFrom = (markup, selector, target) => {
    if (!markup || !target) return false;
    const doc = new DOMParser().parseFromString(markup, 'text/html');
    const source = doc.querySelector(selector);
    if (!source) return false;
    target.innerHTML = source.innerHTML;
    return true;
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('.bb-upsell__add');
    if (!button || button.disabled) return;

    const items = document.getElementById('main-cart-items');
    const sections = ['cart-drawer', 'cart-icon-bubble'];
    if (items && items.dataset.id) sections.push(items.dataset.id);

    const label = button.dataset.label || button.textContent;
    button.disabled = true;
    button.textContent = button.dataset.loading || label;

    try {
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
          sections,
          sections_url: window.location.pathname,
        }),
      });
      const state = await response.json();
      if (state.status) throw new Error(state.description || state.message);
      const html = state.sections || {};

      replaceFrom(html['cart-drawer'], '#CartDrawer', document.querySelector('#CartDrawer'));
      replaceFrom(html['cart-icon-bubble'], '.shopify-section', document.getElementById('cart-icon-bubble'));
      if (items && items.dataset.id) {
        replaceFrom(html[items.dataset.id], '.js-contents', items.querySelector('.js-contents'));
      }

      const drawer = document.querySelector('cart-drawer');
      if (drawer && !items) {
        drawer.classList.remove('is-empty');
        if (typeof drawer.open === 'function') setTimeout(() => drawer.open(), 10);
      }
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bb-cart-upsell', cartData: state });
      }
    } catch (error) {
      button.textContent = label;
      button.disabled = false;
      window.location.href = window.routes.cart_url;
    }
  });
})();
